import { UseFormReturn } from "react-hook-form";
import { ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";

import TextEditor from "../Global/Editors/TextEditor";
import { useGlobalData } from "../GlobalDataProvider";
import { DTOBuilding } from "../../types/building";
import { Button, Card } from "react-bootstrap";
import WizardModuleTable, { WizardModuleTableStyles } from "./WizardModuleTable";

interface IProps {
  building: DTOBuilding;
  formHook: UseFormReturn;
  onAddModule: (mt: ModuleTypeId) => void;
  onRemoveModule: (mId: Number) => void;
}

const WizardPage2 = ({ building, formHook, onAddModule, onRemoveModule }: IProps) => {
  const globalData = useGlobalData();
  const ventModuleTypes = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.Ventilation);
  const ventModules = building.modules.filter((m) => ventModuleTypes.find((mt) => mt.id === m.moduleTypeId));

  return (
    <>
      <Card.Title className="pt-4">Ventilationssystem</Card.Title>
      <WizardModuleTable
        modules={ventModules}
        moduleTypes={ventModuleTypes}
        tableStyle={WizardModuleTableStyles.Ventilation}
        onRemoveModule={onRemoveModule}
        onAddModule={onAddModule}
        formHook={formHook}
      />
    </>
  );
};

export default WizardPage2;
